import { createStore } from "vuex";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    // Drawer del sidenav en mobile/tablet (<1200px, breakpoint "xl" de
    // Bootstrap). Separado de "isPinned" (que es la minimización a solo
    // íconos en escritorio) a propósito: son dos comportamientos distintos
    // del mismo botón hamburguesa según el ancho de pantalla, y mezclarlos
    // en un solo booleano causaba que el primer click en mobile no hiciera
    // nada (el estado inicial de Vuex no coincidía con las clases con las
    // que arranca #app en index.html).
    mobileSidenavOpen: false,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    // Sin cambios respecto al comportamiento original: minimiza el sidenav
    // a solo íconos en escritorio (>=1200px). En mobile/tablet usar
    // toggleMobileSidenav/closeMobileSidenav en su lugar.
    sidebarMinimize(state) {
      let sidenav_show = document.querySelector("#app");
      if (state.isPinned) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      }
    },
    // Abre/cierra el drawer del sidenav en mobile/tablet. Solo toca
    // "g-sidenav-pinned" (la clase que el SCSS del tema ya usa para sacar
    // el sidenav de su posición fuera-de-pantalla por debajo de 1200px),
    // sin tocar "g-sidenav-hidden" para no interferir con el minimizado de
    // escritorio si el usuario redimensiona la ventana en la misma sesión.
    toggleMobileSidenav(state) {
      state.mobileSidenavOpen = !state.mobileSidenavOpen;
      document
        .querySelector("#app")
        .classList.toggle("g-sidenav-pinned", state.mobileSidenavOpen);
    },
    closeMobileSidenav(state) {
      state.mobileSidenavOpen = false;
      document.querySelector("#app").classList.remove("g-sidenav-pinned");
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
  },
  getters: {},
});
